<script lang="ts" setup>
import { getDatesInMonth, isSameDate } from '@/utilities/dateutils';
import { computed } from 'vue';
import { t } from 'i18next';
import { ButtonComp } from '@/components';

const props = defineProps<{
    displayMonth: Date;
    parentBound: Date;
}>();

const emits = defineEmits(['update:parentBound']);

const today = new Date(); // This should probably be reactive if someone uses admin for the midnight cutoff, but fuckit, we're living dangerously

const days = computed(() => {
    let datesInMonth = getDatesInMonth(props.displayMonth);

    // Fill the dates until we have monday as the first
    while (datesInMonth[0].getDay() != 1) {
        const daybefore = new Date(datesInMonth[0]);
        daybefore.setDate(daybefore.getDate() - 1);
        datesInMonth = [daybefore, ...datesInMonth];
    }

    // Fill dates until we have sunday as the last
    while (datesInMonth[datesInMonth.length - 1].getDay() != 0) {
        const dayafter = new Date(datesInMonth[datesInMonth.length - 1]);
        dayafter.setDate(dayafter.getDate() + 1);
        datesInMonth = [...datesInMonth, dayafter];
    }
    return datesInMonth;
});
</script>

<template>
    <div class="dateinput-grid grid-days">
        <span
            v-for="d in days.slice(0, 7)"
            :key="d.getTime()"
            class="text-center text-muted fw-light"
        >
            {{
                t('\{\{val, datetime\}\}', {
                    val: new Date(d),
                    formatParams: { val: { weekday: 'short' } },
                    interpolation: { escapeValue: false },
                }).replace('.', '')
            }}
        </span>
        <ButtonComp
            button-type="Custom"
            class="text-center p-1"
            :class="{
                'border border-secondary': isSameDate(today, d),
                'btn-success': isSameDate(parentBound, d),
                'btn-secondary': !isSameDate(parentBound, d),
            }"
            v-for="d in days"
            :key="d.getTime()"
            @click="() => emits('update:parentBound', d)"
        >
            {{ d.getDate() }}
        </ButtonComp>
    </div>
</template>
